import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=f3ba61e8&scoped=true"
import script from "./Result.vue?vue&type=script&lang=ts"
export * from "./Result.vue?vue&type=script&lang=ts"
import style0 from "./Result.vue?vue&type=style&index=0&id=f3ba61e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ba61e8",
  null
  
)

export default component.exports